import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { bool, object, string } from 'prop-types';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: p => (p.isNewSignup ? 'absolute' : 'relative'),
    // eslint-disable-next-line
    top: p => (p.isNewSignup ? p.newSignupHeader ? 216 : 124 : 80),
    margin: p => (p.isNewSignup ? '0 16px 16px' : 'auto'),
    boxShadow: `0 20px 40px 0 rgba(0, 0, 0, 0.5), 0 4px 0 0 ${theme.palette.colors.corePink}`,
    [theme.breakpoints.up('xs')]: {
      // width: p => (p.isNewSignup ? 'calc(100% - 32px)' : '100%'),
      width: 'calc(100% - 32px)',
    },
    [theme.breakpoints.up('sm')]: {
      width: p => (p.isNewSignup ? '920px' : '624px'),
      minHeight: '604px',
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      marginTop: '120px',
      margin: 'auto',
      left: p => (p.isNewSignup ? '50%' : 'unset'),
      transform: p => (p.isNewSignup ? 'translateX(-50%)' : 'unset'),
    },
    [theme.breakpoints.up('md')]: {
      width: p => (p.isNewSignup ? '920px' : '624px'),
      margin: 'auto',
      left: p => (p.isNewSignup ? '50%' : 'unset'),
      transform: p => (p.isNewSignup ? 'translateX(-50%)' : 'unset'),
      minHeight: '649px',
      marginTop: '86px',
    },
  },
}));

const FormWrapper = ({
  isAgl,
  market,
  children,
  newSignupHeader,
}) => {
  const isNewSignup = ['EMPTY'].indexOf(market) > -1;
  const classes = useStyles({ isNewSignup, newSignupHeader });

  return (
    <section className={!isAgl && classes.wrapper}>
      {
        children
      }
    </section>
  );
};

FormWrapper.propTypes = {
  isAgl: bool,
  market: string,
  children: object.isRequired,
  newSignupHeader: object,
};

export default FormWrapper;
